import React from "react";
import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaCheckCircle,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTiktok,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import Header from "./Header";
import Footer from "./Footer";
import "./SocialLandingPage.css";

const socials = [
  {
    name: "Facebook",
    handle: "@GoOurHub",
    icon: <FaFacebookF />,
    url: "https://www.facebook.com/profile.php?id=61560982405400",
    live: true,
    theme: "facebook",
    description: "Announcements, community updates, and featured business highlights.",
  },
  {
    name: "Instagram",
    handle: "@goourhub",
    icon: <FaInstagram />,
    url: "https://www.instagram.com/goourhub/",
    live: true,
    theme: "instagram",
    description: "Visual updates, local stories, and a closer look at what’s growing.",
  },
  {
    name: "TikTok",
    handle: "Coming soon",
    icon: <FaTiktok />,
    url: "",
    live: false,
    theme: "tiktok",
    description: "Short-form local stories, community energy, and fast updates.",
  },
  {
    name: "X / Twitter",
    handle: "Coming soon",
    icon: <FaTwitter />,
    url: "",
    live: false,
    theme: "twitter",
    description: "Quick updates, launches, and platform news as we grow.",
  },
  {
    name: "LinkedIn",
    handle: "Coming soon",
    icon: <FaLinkedinIn />,
    url: "",
    live: false,
    theme: "linkedin",
    description: "Business-facing updates, partnerships, and professional visibility.",
  },
  {
    name: "YouTube",
    handle: "Coming soon",
    icon: <FaYoutube />,
    url: "",
    live: false,
    theme: "youtube",
    description: "Longer-form stories, featured businesses, and local spotlight content.",
  },
];

function SocialCard({ social }) {
  if (!social.live) {
    return (
      <div
        className={`social-card social-card--soon social-card--${social.theme}`}
        aria-label={`${social.name} coming soon`}
      >
        <div className="social-card__top">
          <span className="social-card__icon">{social.icon}</span>
          <span className="social-card__badge social-card__badge--soon">Coming soon</span>
        </div>

        <h3>{social.name}</h3>
        <p className="social-card__handle">{social.handle}</p>
        <p className="social-card__text">{social.description}</p>

        <div className="social-card__ghost-btn">Channel in progress</div>
      </div>
    );
  }

  return (
    <a
      href={social.url}
      target="_blank"
      rel="noopener noreferrer"
      className={`social-card social-card--live social-card--${social.theme}`}
      aria-label={`Visit ${social.name}`}
    >
      <div className="social-card__top">
        <span className="social-card__icon">{social.icon}</span>
        <span className="social-card__badge">Live now</span>
      </div>

      <h3>{social.name}</h3>
      <p className="social-card__handle">{social.handle}</p>
      <p className="social-card__text">{social.description}</p>

      <span className="social-card__action">
        Visit channel
        <FaArrowRight />
      </span>
    </a>
  );
}

 
function SocialLandingPage() {
  return (
    <div className="social-page-shell">
      <Header />

      <main className="social-page">
        <section className="social-hero-card">
          <div className="social-hero-copy">
            <span className="social-kicker">Connect with GoOurHub</span>
            <h1>Follow the brand where the story keeps moving.</h1>
            <p className="social-intro">
              Stay close to platform updates, featured businesses, community
              highlights, and the next moves we’re building across GoOurHub and HubMart.
            </p>

            <div className="social-proof-row">
              <span className="social-proof-pill">
                <FaCheckCircle />
                Community-focused updates
              </span>
              <span className="social-proof-pill">
                <FaCheckCircle />
                Business visibility
              </span>
              <span className="social-proof-pill">
                <FaCheckCircle />
                More channels coming soon
              </span>
            </div>
          </div>

          <div className="social-side-card">
            <span className="social-side-card__kicker">Why follow?</span>
            <h2>See what’s growing before everyone else does.</h2>
            <p>
              We’re building local discovery, better visibility, and a cleaner
              marketplace flow. Social is where you’ll catch updates first.
            </p>

            <div className="social-side-card__actions">
              <Link to="/partner-signup" className="social-btn social-btn--primary">
                Join Us
              </Link>
              <Link to="/contact" className="social-btn social-btn--secondary">
                Contact Us
              </Link>
            </div>
          </div>
        </section>

        <section className="social-grid-section">
          <div className="social-grid-heading">
            <div>
              <span className="social-section-kicker">Our channels</span>
              <h2>Meet GoOurHub across social</h2>
            </div>
            <p>
              Follow the live channels now, and keep an eye on the rest as the brand expands.
            </p>
          </div>

          <div className="social-grid">
            {socials.map((social) => (
              <SocialCard key={social.name} social={social} />
            ))}
          </div>
        </section>

        <section className="social-cta-band">
          <div>
            <span className="social-section-kicker">Grow with us</span>
            <h2>Want your brand in the right conversation?</h2>
            <p>
              Partner with GoOurHub, build visibility, and get in front of the
              right audience with less noise and more clarity.
            </p>
          </div>

          <div className="social-cta-band__actions">
            <Link to="/partner-signup" className="social-btn social-btn--gold">
              Become a Partner
            </Link>
            <Link to="/HubMart" className="social-btn social-btn--secondary">
              Visit HubMart
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default SocialLandingPage;